import React from 'react';
import { Box } from '@mui/material';
import NereusIcon, { NEREUS_GRADIENT } from './NereusIcon';

interface Props {
  /** Diameter in px. Defaults to 32. */
  size?: number;
}

/**
 * Circular Nereus avatar — the trident mark in white on the deep-sea
 * gradient. Used wherever Nereus "speaks" (chat headers, message bubbles,
 * empty states) so the bot keeps its ocean identity in every app theme.
 */
const NereusAvatar: React.FC<Props> = ({ size = 32 }) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: '50%',
      background: NEREUS_GRADIENT,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#FFFFFF',
      flexShrink: 0,
      boxShadow: '0 1px 3px rgba(4, 54, 92, 0.35)',
    }}
  >
    <NereusIcon sx={{ fontSize: Math.round(size * 0.62) }} />
  </Box>
);

export default NereusAvatar;
